/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import cn from 'clsx';
import Select from 'components/Molecules/FormFields/Select';
import classes from './SelectCreate.module.scss';

const SelectCreate = ({ className, radius, ...other }) => {
  return (
    <Select
      {...other}
      className={cn(classes.wrapper, classes[`radius_${radius}`], className)}
      creatable
    />
  );
};

export default SelectCreate;
